import { Header } from "components/Common/Header";
import { EventList } from "components/EventList/eventList";
import { useEvents } from "hooks/useEvents";

/**
 * Just for test purpose to view all events in one place
 */
function DogPound() {
  const events = useEvents();

  return (
    <>
      <Header />

      <EventList events={events} dogPound />
    </>
  );
}

export { DogPound };
